<template>
  <div class="tomorrow-pre-consultation">
    <!-- 顶部：预约概要 -->
    <div class="summary-section">
      <div class="summary-item row">
        <div class="flex-1">
          <span class="label font-666">就诊:</span>
          <span class="value font-333"
            >{{ $filters.formatDateTime(self.appointTime) }}
            {{ self.doctorName }}</span
          >
        </div>
        
       <!--状态-->
           <div class="statusRight">
          {{ self.statusText }}
        </div>

    </div>

    <!-- 已沟通：列表展示沟通人、时间、内容与「修改」 -->
    <div
      class="communication-section mt8"
      v-if="completedReturnVisitRows.length > 0"
    >
      <div
        v-for="(visitRow, rowIndex) in completedReturnVisitRows"
        :key="visitRow.returnVisitId || rowIndex"
        class="communication-record-item"
      >
        <div class="communication-record-head row">
          <div class="communication-meta flex-1">
            <span class="meta-label font-666">沟通:</span>
            <span class="meta-text font-333">{{
              visitRow.executorName || "—"
            }}</span>
            <span class="meta-text font-333">{{
              formatRowTimeDisplay(visitRow)
            }}</span>
          </div>
          <button
            v-if="checkIfEmployeeCanEditReturnVisit(visitRow)"
            type="button"
            class="edit-outline-btn"
            @click="handleEdit(visitRow)"
          >
            修改
          </button>
        </div>
        <div class="communication-record-body font-333">
          {{ visitRow.returnVisitContent }}
        </div>
      </div>
    </div>

    <!-- 待沟通 -->
    <div class="content-section mt12" v-if="self.returnVisitStatus === 0">
      <div class="record-btn" @click="recordCommunication">记录沟通内容</div>
    </div>
  </div>
  </div>
</template>

<script>
import { todayTodoStore } from "@/store/h5/todayTodo.js";
import { userStore } from "@/store/user.js";

/** 与接口 returnVisitStatus 一致 */
const RETURN_VISIT_STATUS = {
  PENDING: 0,
  DONE: 1,
};

export default {
  name: "TomorrowPreConsultation",
  props: {
    self: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    /**
     * 已沟通记录行：合并项带 returnVisitHistoryList；单条已沟通无列表时用 self
     */
    completedReturnVisitRows() {
      const historyList = this.self.returnVisitHistoryList;
      if (historyList && historyList.length) {
        return historyList;
      }
      if (this.self.returnVisitStatus === RETURN_VISIT_STATUS.DONE) {
        return [this.self];
      }
      return [];
    },
  },
  methods: {
    formatRowTimeDisplay(visitRow) {
      const timeValue =
        visitRow.returnVisitTime ||
        visitRow.updateTime ||
        visitRow.gmtCreate ||
        visitRow.appointTime;
      return this.$filters.formatDateTime(timeValue);
    },
    checkIfEmployeeCanEditReturnVisit(visitRow) {
      const user = userStore();
      const employeeId = user.userInfo.detail.employee_id;
      return (
        visitRow.executorId == employeeId &&
        visitRow.returnVisitStatus === RETURN_VISIT_STATUS.DONE
      );
    },
    handleEdit(visitRow) {
      const todayTodoStoreInstance = todayTodoStore();
      todayTodoStoreInstance.setCurrentPreDiagnosis(visitRow);
      this.$router.push("/todayTodo/regCommStatus?type=tomorrow&status=2");
    },
    recordCommunication() {
      const todayTodoStoreInstance = todayTodoStore();
      todayTodoStoreInstance.setCurrentPreDiagnosis(this.self);
      this.$router.push("/todayTodo/regCommStatus?type=tomorrow&status=1");
    },
  },
};
</script>

<style lang="scss" scoped>
.tomorrow-pre-consultation {
  background-color: #fff;
  border: 1px solid #e6e6e6;
  border-radius: 0.083rem;
  padding: 0.25rem;
  margin-bottom: 0.25rem;
  text-align: left;
  box-sizing: border-box;

  .summary-section {
    .summary-item {
      display: flex;
      align-items: center;

      .label {
        font-size: 0.25rem;
        flex-shrink: 0;
        min-width: 1.25rem;
      }

      .value {
        font-size: 0.25rem;
        margin-left: 0.042rem;
        flex: 1;
      }

      .statusRight {
        font-size: .25rem;
        color: #999999;
        text-align: right;
        background-color: #fafafa;
        padding: .042rem .083rem;
        border-radius: .083rem;
      }

    }
  }

  .communication-section {
    margin-top: .292rem;
    .communication-record-item {
      margin-bottom: 0.25rem;

      &:last-child {
        margin-bottom: 0;
      }
    }

    .communication-record-head {
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.083rem;
    }

    .communication-meta {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      font-size: 0.25rem;
      line-height: 1.5;
    }

    .meta-label {
      flex-shrink: 0;
      margin-right: 0.042rem;
    }

    .meta-text {
      margin-right: 0.083rem;
    }

    .edit-outline-btn {
      flex-shrink: 0;
      margin-left: 0.125rem;
      padding: 0.042rem 0.167rem;
      font-size: 0.25rem;
      color: #333;
      background-color: #fff;
      border: 1px solid #dcdcdc;
      border-radius: 0.083rem;
      line-height: 1.4;
      cursor: pointer;
    }

    .communication-record-body {
      font-size: 0.25rem;
      line-height: 1.6;
      word-break: break-all;
      white-space: pre-wrap;
      overflow-wrap: break-word;
    }
  }

  .content-section {
    .record-btn {
      width: 5rem;
      background-color: #fff;
      color: #28b8c3;
      border: 1px solid #28b8c3;
      padding: 0.167rem 0;
      border-radius: 0.083rem;
      text-align: center;
      font-size: 0.292rem;
      cursor: pointer;
      margin: 0 auto;
      margin-top: 0.208rem;
    }
  }
}
</style>
